var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page about"},[_c('b-container',[_c('section',{staticClass:"section"},[_c('h1',{staticClass:"h1 semibold mb-2"},[_vm._v("Chi siamo")]),_c('p',[_vm._v(" La nostra società è leader in Italia nella fornitura di soluzioni business di online travel booking. Le nostre soluzioni vengono utilizzate da alcune tra le più innovative aziende italiane nel welfare aziendale, nel marketing, nei piani loyalty e nelle incentivazioni aziendali al trade. ")]),_c('p',[_vm._v(" Ci avvaliamo di avanzate tecnologie IT e di collaborazioni con i leader globali del travel online ma manteniamo anche una caratterizzazione territoriale. Infatti, tutto il nostro staff, dallo sviluppo tecnologico all'assistenza clienti passando per lo sviluppo strategico e commerciale, si trova nella nostra sede in provincia di Rimini. ")])]),_c('section',{staticClass:"section"},[_c('info-banner',{attrs:{"title":"La nostra mission","image":"/assets/images/liveflight/about/about-1.jpg","description":`
          <span class='d-flex flex-column'>
            <span class='mb-1'>
              La nostra mission è quella di realizzare soluzioni di travel booking fortemente
              orientate all'utente.
            </span>
            <span>
              Lo sviluppo tecnologico e la cura dell'assistenza clienti danno sicurezza e
              tranquillità ai viaggiatori che prenotano con
              ${_vm.site.brand}. Le aziende che affidano i loro dipendenti e i loro clienti ai nostri
              servizi sanno di poter contare su un servizio a loro dedicato che non trova riscontro
              negli altri player del settore.
            </span>
          </span>`,"direction":"left"}})],1),_c('section',{staticClass:"section"},[_c('hr')]),_c('content-section',{attrs:{"icon":"quote","title":`${_vm.site.payoff} ${_vm.site.brand}`,"description":`${_vm.site.payoff} ${_vm.site.brand} è un sito di prenotazione voli
          facile e semplice da usare che ti permette di avere accesso ai
          servizi proposti sui circuiti internazionali da tutte le principali
          compagnie aeree tradizionali e low cost in Italia, in Europa e nel
          mondo.`}}),_c('section',{staticClass:"section"},[_c('hr')]),_c('section',{staticClass:"section"},[_c('info-banner',{attrs:{"title":"Contatti","image":"/assets/images/liveflight/about/about-2-2.jpg","description":`
          <span class='d-flex flex-column'>
            <span class='mb-4'>
              ${_vm.site.payoff} ${_vm.site.brand} è un servizio di Salabam srl
            </span>
            <ul class='list-unstyled'>
            <li>
              <b>Assistenza clienti:</b>
              <a href='${_vm.faq_href}'>clicca qui!</a>
            </li>
            ${
              _vm.site.emailBusiness !== ''
                ? `
              <li>
                <b>Servizi business:</b>
                <a href='mailto:${_vm.site.emailBusiness}'>
                  ${_vm.site.emailBusiness}
                </a>
              </li>
            `
                : ''
            }
          </ul>
          </span>`}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }